var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.ad.dtp_comment),expression:"ad.dtp_comment"}],staticClass:"fa fa-comment",style:({opacity: _vm.ad.dtp_comment ? 1 : 0.2})})
}
var staticRenderFns = []

export { render, staticRenderFns }